/**
 * Neya Systems, LLC disclaims all warranties with regard to this software,
 * including all implied warranties of merchantability and fitness, in no
 * event shall Neya Systems, LLC be liable for any special, indirect or
 * consequential damages or any damages whatsoever resulting from loss of
 * use, data or profits, whether in an action of contract, negligence or
 * other tortious action, arising out of or in connection with the use or
 * performance of this software.
 *
 * "Copyright (c) 2020 Neya Systems, LLC, all rights reserved."
 *
 * This work contains valuable confidential and proprietary information.
 * Disclosure or reproduction without the written authorization of Neya
 * Systems, LLC is prohibited. This unpublished work by Neya Systems, LLC
 * is protected by the laws of the United States and other countries. If
 * publication of the work should occur, the following notice shall apply.
 */

import {
    FETCH_DATASET_ERROR,
    FETCH_DATASET_PENDING,
    FETCH_DATASET_SUCCESS
} from '../actions/datasetActions'

const INITIAL_STATE = {
    pending: false,
    selectedDataset: null,
    error: null,
}

export function datasetReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_DATASET_PENDING:
            return {
                ...state,
                pending: true,
                selectedDataset: null,
                error: null
            }
        case FETCH_DATASET_SUCCESS:
            return {
                ...state,
                pending: false,
                selectedDataset: action.dataset,
                error: null
            }
        case FETCH_DATASET_ERROR:
            return {
                ...state,
                pending: false,
                error: action.error,
                selectedDataset: null
            }
        default:
            return state
    }
}

export const getSelectedDataset = state => state.dataset.selectedDataset
export const getDatasetPending = state => state.dataset.pending
export const getDatasetError = state => state.dataset.error